var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { OptionGraphLoaderTypes, } from "@domains/features/Markets/Options/entites/iOptionChain";
import { FnoBanEnum } from "../../Common/action-interface/fnoBan";
import { IFnoBanMsg, IFnoBanSectionType, } from "@domains/features/Markets/Common/entities/iFnoBan";
import { SecurityFNOBanMessage } from "@domains/features/Markets/Futures/utils/messageCreatpr";
import { DrivingMarketMsgIcon } from "@domains/features/Markets/Equity/entities/iDrivingMarket";
import { streamKeys } from "@adapters/repositories/stream/QuoteResponseMappper";
import { STREAMING_TYPE } from "@adapters/repositories/stream/IQuoteStreamRepo";
import { StreamingSectionName } from "@adapters/repositories/stream/QuoteStreamRepo";
var OptionPresenter = /** @class */ (function () {
    function OptionPresenter(usecase, actions, optionGraph, optionDrivingMarkets, useCasesStream) {
        this.usecase = usecase;
        this.actions = actions;
        this.optionGraph = optionGraph;
        this.optionDrivingMarkets = optionDrivingMarkets;
        this.useCasesStream = useCasesStream;
        this.newAction = this.actions;
        this.optionChainSymbols = [];
        this.streamButton = true;
    }
    OptionPresenter.prototype.drivingMarketStream = function (subscribe, symbols, sectionName) {
        this.optionDrivingMarkets.drivingMarketStream(subscribe, symbols, sectionName);
    };
    OptionPresenter.prototype.FNOBanHandleMessages = function (stockList, type, sectionType) {
        if (stockList.length < 5) {
            this.actions.fnoBanActions.setFnoBanMsg({
                msg: SecurityFNOBanMessage(stockList.length, sectionType),
                show: true,
                icon: DrivingMarketMsgIcon.EMPTYSTOCK,
            }, type, FnoBanEnum.OP);
        }
    };
    OptionPresenter.prototype.getFnoBanDataOption = function () {
        var _this = this;
        this.actions.fnoBanActions.clearFnoBanMsg(IFnoBanMsg.SECURITIES, FnoBanEnum.OP);
        this.actions.fnoBanActions.clearFnoBanMsg(IFnoBanMsg.POSSIBLE_EXITS, FnoBanEnum.OP);
        this.actions.fnoBanActions.clearFnoBanMsg(IFnoBanMsg.POSSIBLE_ENTRANCE, FnoBanEnum.OP);
        this.actions.fnoBanActions.hideError(FnoBanEnum.OP);
        this.actions.fnoBanActions.startFnoBanloader(FnoBanEnum.OP);
        this.usecase.fnoBanUseCase.execute({
            onSuccess: function (data) {
                _this.FNOBanHandleMessages(data.securities.stockList, IFnoBanMsg.SECURITIES, IFnoBanSectionType.SECURITIES);
                _this.FNOBanHandleMessages(data.possibleExits.stockList, IFnoBanMsg.POSSIBLE_EXITS, IFnoBanSectionType.POSSIBLE_EXITS);
                _this.FNOBanHandleMessages(data.possibleEntrance.stockList, IFnoBanMsg.POSSIBLE_ENTRANCE, IFnoBanSectionType.POSSIBLE_ENTRANCE);
                _this.actions.fnoBanActions.getFnoBanData(data, FnoBanEnum.OP);
                _this.actions.fnoBanActions.stopFnoBanLoader(FnoBanEnum.OP);
            },
            onError: function (error) {
                _this.actions.fnoBanActions.setError({ isOpen: true, error: error });
                _this.actions.fnoBanActions.stopFnoBanLoader(FnoBanEnum.OP);
            },
        }, null);
    };
    OptionPresenter.prototype.getOptionChainData = function (req) {
        var _this = this;
        this.actions.optionChainActions.hideError();
        this.actions.optionChainActions.loader();
        this.usecase.optionChain.execute({
            onSuccess: function (data) {
                if (data) {
                    // data.optionChain.map((x) => {
                    //   if (
                    //     x.call.symbol != "" &&
                    //     !this.optionChainSymbols.includes(x.call.symbol)
                    //   ) {
                    //     this.optionChainSymbols.push(x.call.symbol);
                    //   }
                    //   if (
                    //     x.put.symbol != "" &&
                    //     !this.optionChainSymbols.includes(x.put.symbol)
                    //   ) {
                    //     this.optionChainSymbols.push(x.put.symbol);
                    //   }
                    // });
                    if (!_this.optionChainSymbols.includes(data.future.symbol))
                        _this.optionChainSymbols.push(data.future.symbol);
                    if (!_this.optionChainSymbols.includes(data.spot.symbol))
                        _this.optionChainSymbols.push(data.spot.symbol);
                    _this.actions.optionChainActions.getOptionChainData(data);
                }
                _this.actions.optionChainActions.stopLoader();
            },
            onError: function (error) {
                _this.actions.optionChainActions.setError({ isOpen: true, error: error });
                _this.actions.optionChainActions.stopLoader();
            },
        }, req);
    };
    OptionPresenter.prototype.optionChainStreaming = function (subscribe, symbols, viewAll) {
        var _this = this;
        var streamMapKey = [
            streamKeys[0],
            streamKeys[1],
            streamKeys[2],
            streamKeys[3],
            streamKeys[4],
            streamKeys[5],
            //streamKeys[6],
            // streamKeys[7],
            streamKeys[8],
            // streamKeys[9],
            // streamKeys[12],
            // streamKeys[13],
            // streamKeys[14],
            // streamKeys[23],
            // streamKeys[24],
        ];
        if ((symbols === null || symbols === void 0 ? void 0 : symbols.length) > 0)
            symbols.push.apply(symbols, __spreadArray([], __read(this.optionChainSymbols), false));
        this.useCasesStream.streamQuote(STREAMING_TYPE.MINIQUOTE, subscribe, function (mappedData) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (symbols.includes(mappedData.symbol)) {
                    this.actions.optionChainActions.optionChainStreamingUpdate(mappedData);
                }
                return [2 /*return*/];
            });
        }); }, symbols, streamMapKey, StreamingSectionName.OPTION_CHAIN);
    };
    OptionPresenter.prototype.getScreenData = function (req) {
        this.optionGraph.getScreenData(req);
    };
    OptionPresenter.prototype.getNewOnEdelData = function () {
        var _this = this;
        this.actions.newOnEdelActions.hideError();
        this.actions.newOnEdelActions.setStartNewOnEdelLoader();
        this.usecase.newOnEdelUseCase.execute({
            onSuccess: function (data) {
                _this.actions.newOnEdelActions.getNewOnEdelData(data);
                _this.actions.newOnEdelActions.setStopNewOnEdelLoader();
            },
            onError: function (error) {
                _this.actions.newOnEdelActions.setStopNewOnEdelLoader();
                _this.actions.newOnEdelActions.setError({ isOpen: true, error: error });
            },
        }, null);
    };
    OptionPresenter.prototype.getExpiryDateData = function () {
        var _this = this;
        this.actions.optionGraphActions.setGrpahLoader(OptionGraphLoaderTypes.OPTION_MAIN_LOADER);
        this.actions.optionChainActions.loader();
        this.usecase.expiryDateUseCase.execute({
            onSuccess: function (data) {
                _this.actions.optionChainActions.updateExpiryDateData(data);
                _this.actions.optionGraphActions.updateExpiryDateData(data);
                _this.actions.optionGraphActions.stopGraphLoader(OptionGraphLoaderTypes.OPTION_MAIN_LOADER);
            },
            onError: function (error) {
                _this.actions.optionChainActions.stopLoader();
                _this.actions.optionGraphActions.stopGraphLoader(OptionGraphLoaderTypes.OPTION_MAIN_LOADER);
            },
        }, null);
    };
    OptionPresenter.prototype.getOpRecommendationData = function () {
        var _this = this;
        this.actions.opRecActions.hideError();
        this.actions.opRecActions.loader();
        this.usecase.OpRecommendationsUseCase.execute({
            onSuccess: function (data) {
                if (data) {
                    _this.actions.opRecActions.getOpRecommendationData(data);
                }
                _this.actions.opRecActions.stopLoader();
            },
            onError: function (error) {
                _this.actions.opRecActions.setError({ isOpen: true, error: error });
                _this.actions.opRecActions.stopLoader();
            },
        }, null);
    };
    OptionPresenter.prototype.getOptionsUnderstandingSectionData = function () {
        var _this = this;
        this.actions.understandingSectionActions.hideError();
        this.actions.understandingSectionActions.startUnderstandingSectionLoader();
        this.usecase.understandingSection.execute({
            onSuccess: function (data) {
                _this.actions.understandingSectionActions.getMarketUnderstandingSectionData(data);
                _this.actions.understandingSectionActions.stopUnderstandingSectionLoader();
            },
            onError: function (error) {
                _this.actions.understandingSectionActions.stopUnderstandingSectionLoader();
                _this.actions.understandingSectionActions.setError({
                    isOpen: true,
                    error: error,
                });
            },
        }, null);
    };
    OptionPresenter.prototype.getDrivingMarketData = function (req) {
        this.optionDrivingMarkets.getAllData(req);
    };
    OptionPresenter.prototype.displayUnderStandingSection = function (data, limit) {
        limit
            ? this.actions.understandingSectionActions.displayUnderStandingSection(data)
            : this.actions.understandingSectionActions.displayUnderStandingSection(data.slice(0, 3));
    };
    OptionPresenter.prototype.optionDrivingMarketStreamViewAll = function (subscribe, symbols, callBack) {
        this.optionDrivingMarkets.optionDrivingMarketStreamViewAll(subscribe, symbols, callBack);
    };
    OptionPresenter.prototype.getBseNseExpiryDates = function () {
        var _this = this;
        this.actions.bseNseExpiry.hideError();
        this.actions.optionGraphActions.setGrpahLoader(OptionGraphLoaderTypes.OPTION_MAIN_LOADER);
        this.actions.optionChainActions.loader();
        this.usecase.nseBseExpiry.execute({
            onSuccess: function (data) {
                if (data) {
                    _this.actions.bseNseExpiry.getBseNseExpiryDates(data);
                }
                _this.actions.optionGraphActions.stopGraphLoader(OptionGraphLoaderTypes.OPTION_MAIN_LOADER);
                _this.actions.optionChainActions.stopLoader();
            },
            onError: function (error) {
                _this.actions.bseNseExpiry.setError({ isOpen: true, error: error });
                _this.actions.optionGraphActions.stopGraphLoader(OptionGraphLoaderTypes.OPTION_MAIN_LOADER);
                _this.actions.optionChainActions.stopLoader();
            },
        }, null);
    };
    return OptionPresenter;
}());
export default OptionPresenter;
